export const termsAndConditionsUrl = 'https://www.tumelo.com/terms-and-conditions'

export const privacyPolicyUrl = 'https://www.tumelo.com/privacy-policy'

export const cookiesPolicyUrl = 'https://www.tumelo.com/cookies-policy'
